/* global */
import { createStore } from 'vuex'
import VuexTurbo from '../vuex-turbolinks'
// Store imports
import hotel from './modules/hotel'
import packages from './modules/packages'
import order from './modules/order'
import order_item from './modules/order-item'
import event from './modules/event'
import cart from './modules/cart'
import checkout from './modules/checkout'
import reservation from './modules/reservation'

const plugins = [
  VuexTurbo
]

export const store = createStore({
  modules: {
    hotel,
    packages,
    order,
    order_item,
    event,
    checkout,
    cart,
    reservation
  },
  plugins
})

 

